export default () => {
  return navigator.language.slice(0, navigator.language.indexOf('-')).toLowerCase()
}
